import { forwardRef } from "react";
import { mergeProps } from "../../shared";
import { Text } from "../../typography";
import { useTabsContext } from "./TabsContext";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerTabPanel({
  as = DefaultElement,
  children,
  forwardedRef,
  panel: {
    key,
    panelId,
    tabId
  },
  ...rest
}) {
  const {
    selectedKey
  } = useTabsContext();
  return /*#__PURE__*/_jsx(Text, { ...mergeProps(rest, {
      "aria-labelledby": tabId,
      as,
      className: "o-ui-tab-panel",
      hidden: key !== selectedKey,
      id: panelId,
      ref: forwardedRef,
      role: "tabpanel"
    }),
    children: children
  });
}
InnerTabPanel.defaultElement = DefaultElement;
export const TabPanel = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerTabPanel, { ...props,
  forwardedRef: ref
}));